import { TeamModal } from 'structure/home/components/FoundationTeam/TeamModal';
import { TeamData } from 'structure/home/components/FoundationTeam/types';
import { Card } from 'structure/home/components/FoundationTeam/TeamCard';
import { useState } from 'react';
import { Header2 } from 'structure/home/components/Typography';
import { getStaticAssetUrl } from 'utils/url';

export const founders: TeamData[] = [
  {
    name: 'Ben Goertzel',
    position: 'CEO, Co-Founder, Chief AI Scientist',
    img: getStaticAssetUrl('/sfi/static/homepage/team/ben_goertzel.png'),
    designation: (
      <>
        Dr. Ben Goertzel is the founder and CEO of SingularityNET, a
        decentralized artificial intelligence marketplace that allows for the
        creation, distribution, and monetization of AI services. He has written
        numerous scholarly papers and books on artificial intelligence,
        cognitive science, and philosophy. He has been involved in the
        platform’s development since its beginning, and he was instrumental in
        the design and execution of its AI algorithms. Dr. Goertzel is also the
        co-founder and Chief Scientist Officer of Cogito. His knowledge of
        artificial intelligence and blockchain technology has been instrumental
        in the creation of Cogito, and he remains actively involved in the
        company’s ongoing research and development efforts.
      </>
    ),
  },
  {
    name: 'Mario Casiraghi',
    position: 'Co-Founder',
    img: getStaticAssetUrl('/sfi/static/homepage/team/mario_casiraghi.png'),
    designation: (
      <>
        Mario is an Executive of the Artificial Superintelligence Alliance, CFO
        at SingularityNET, CFO and Co-Founder of SingularityDAO. Mario
        spearheaded growth of the SingularityNET ecosystem since 2020 by leading
        the efforts across spin offs as well as at a SingularityNET level, more
        recently by leading ASI merger related activities . Mario also led the
        SingularityDAO product and quants strategy since the inception in 2021.
        He helped raise $100M+ for blockchain based companies. Formerly covered
        positions at Bank of America Merrill Lynch and RBS. He also completed
        50+ Debt Capital Markets transactions for c. $80bn in total financing.
      </>
    ),
  },
];

interface FoundationTeamProps {
  anchorId: string;
}

export function FoundationTeam({ anchorId }: FoundationTeamProps) {
  const [modalItem, setModalItem] = useState<TeamData | null>(null);

  const onClick = (item: TeamData) => {
    setModalItem(item);
  };

  const handleChangeModal = (open: boolean) => {
    setModalItem(open ? modalItem : null);
  };

  return (
    <div
      id={anchorId}
      className='relative flex h-full flex-col justify-around gap-6 overflow-x-hidden overflow-y-hidden'
    >
      <div className='flex flex-col gap-4 ngxl:gap-6'>
        <Header2 as='h2' className='text-center'>
          Founders
        </Header2>
        {/*<Typography*/}
        {/*  as='div'*/}
        {/*  className='text-center text-[14px] font-light ngxl:text-base ng2xl:text-[20px]'*/}
        {/*>*/}
        {/*  The founding team of the SingularityFinance (SFI) is comprised of AI*/}
        {/*  visionaries, technologists, and thought leaders, who are at the*/}
        {/*  forefront of decentralized Finance, AI, and Artificial General*/}
        {/*  Intelligence (AGI) while navigating the complex regulatory landscape.*/}
        {/*</Typography>*/}
      </div>
      <div className='scrollbar-hide grid w-auto grid-cols-1 justify-items-center gap-x-4 overflow-auto md:w-full md:grid-cols-[repeat(2,_minmax(225px,_1fr))]'>
        {founders.map((data, index) => (
          <Card onClick={onClick} key={index} data={data} />
        ))}
      </div>
      <TeamModal
        item={modalItem as TeamData}
        open={!!modalItem}
        onOpenChange={handleChangeModal}
      />
    </div>
  );
}
